import Error from '@/common/errorData'
import CON from '../../constant'
import {
  http
} from './index'
const pasurl = CON.URL_DOWN

const getReq = (url, data) => { // 封装get参数
  const urls = http.adornUrl(url, pasurl)
  return http.get(urls, {
    params: data
  })
}
const postReq = (url, data) => { // 封装get参数
  const urls = http.adornUrl(url, pasurl)
  return http.post(urls, data)
}
export default {
// 接口提供者:
  studentIndex: (data) => getReq('/student-api/student/index.action', data).then(Error),
  studentCourse: (data) => getReq('/student-api/student/userCourse.action', data).then(Error),
  userCertificate: (data) => getReq('/student-api/student/userCertificateList.action', data).then(Error),
  getUser: (data) => getReq('/student-api/student/user/user.action', data).then(Error),
  getNewUser: (data) => getReq('/student-api/student/user/newuser.action', data).then(Error),
  userCourseNum: (data) => getReq('/student-api/student/userCourseNum.action', data).then(Error),
  logout: (data) => getReq('/student-api/student/login/logout.action', data).then(Error),
  registerUser: (data) => postReq('/subscriber-api/forgot/login/register.action', data),
  getEvaluateByStudentId: (data) => getReq('/student-api/student/getEvaluateByStudentId.action', data).then(Error),
  getStudyDuration: (data) => getReq('/student-api/student/getStudyDuration.action', data).then(Error),
  getTestScore: (data) => getReq('/student-api/student/getTestScore.action', data).then(Error),
  getPieDate: (data) => getReq('/student-api/student/getPieDate.action', data).then(Error),
  getStudentAchievement: (data) => getReq('/student-api/student/getStudentAchievement.action', data).then(Error),

}
